import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getCompanies } from 'services/api/AccessManagerAPI';

// Every live company and its products (SLAI staff only). enabled: false holds
// the request back — for anybody else it is a guaranteed 403.
export const useGetCompanies = (enabled = true) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.companies,
        queryFn: getCompanies,
        enabled,
    });

    return { companiesData: data, isCompaniesLoading: isLoading, ...rest };
};
